import { jsonApi } from '@models/jsonApi';

jsonApi.define('privacy/vendor-reference', {
  public_vendor_id: '',
  vendor_type: '',
  label: '',
  description: '',
  policy_url: '',
});
